import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { isClient } from '@client/shared/utils/utils/utils';

let auth = null;

function getFirebaseConfig() {
  return {
    apiKey: process.env.FIREBASE_API_KEY,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    projectId: process.env.FIREBASE_PROJECT_ID,
    appId: process.env.FIREBASE_APP_ID,
  };
}

// Firebase keeps its Session in the browser, so it is never initialised on the
// server (see ADR 0003).
export function getFirebaseAuth() {
  if (!isClient()) {
    return null;
  }

  if (!auth) {
    auth = getAuth(initializeApp(getFirebaseConfig()));
  }

  return auth;
}
